export const BeforeDay = (date: Date) => {
    let beforeDay = new Date(date.setDate(date.getDate() - 1));
    return beforeDay;
}